import React from 'react';

import {
  SkeletonTable,
  SkeletonHeadingControls,
  SkeletonCtn,
  SkeletonAccumulator,
  SkeletonExpensePageTabs,
} from './components';

const skeletons = {
  table: SkeletonTable,
  controls: SkeletonHeadingControls,
  ctn: SkeletonCtn,
  accumulator: SkeletonAccumulator,
  expensePageTabs: SkeletonExpensePageTabs,
};
export const SkeletonDetalization = ({ name }) => {
  const Skeleton = skeletons[name];

  return (
    <Skeleton />
  );
};
